// App
import React, { useEffect, useRef } from 'react';

// Components
import Button from 'app/shared/modules/MobileSRP/__BaseComponents__/Button';
import FilterButtonDropdown from 'app/shared/modules/MobileSRP/__BaseComponents__/FilterButtonDropdown';
import PriceFilter from 'app/shared/modules/MobileSRP/Header/FilterModules/PriceFilter';

// Hooks
import { usePriceFilterButtonLabel } from './hooks';

type Props = {
  ariaButtonLabel: string;
  ariaDropdownLabel: string;
  onButtonClick: () => void;
  onModalClose: () => void;
  showDropdown: boolean;
};

const PriceFilterButton = ({
  ariaButtonLabel,
  ariaDropdownLabel,
  onButtonClick,
  onModalClose,
  showDropdown,
}: Props) => {
  // All filter buttons should have this ref to return focus after user has closed the filter modal
  const focusRef = useRef<HTMLButtonElement>(null);
  const isLoaded = useRef<boolean>(false);

  useEffect(() => {
    /**
     * isLoaded is a component instance variable. Do not set focus on the button until
     * after the component has been interacted with.
     * @see: https://reactjs.org/docs/hooks-faq.html#is-there-something-like-instance-variables
     */
    if (!isLoaded.current) {
      isLoaded.current = true;
    } else {
      if (!showDropdown) {
        focusRef.current?.focus();
      }
    }
  }, [showDropdown]);

  const [getButtonLabel, getButtonStatus] = usePriceFilterButtonLabel();
  const buttonLabel = getButtonLabel();
  const isFilterActive = getButtonStatus();

  return (
    <>
      <Button
        ariaLabel={ariaButtonLabel}
        ariaExpanded={showDropdown}
        active={isFilterActive}
        onClick={onButtonClick}
        ref={focusRef}
        showCarat
      >
        {buttonLabel}
      </Button>
      {showDropdown && (
        <FilterButtonDropdown ariaLabel={ariaDropdownLabel} dropdownId={'price-filter-dropdown'} onClose={onModalClose}>
          <PriceFilter showResetButton />
        </FilterButtonDropdown>
      )}
    </>
  );
};

export default PriceFilterButton;
